import React, {
  forwardRef,
  ForwardRefRenderFunction,
  useCallback,
  useImperativeHandle,
  useState,
} from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MdOutlineCancel } from "react-icons/md";

import ConfirmationModal from "../../../../../../../components/Dialogs/ConfirmationModal";
import { Color } from "../../../../../../../components/Form/Button";
import useStyles from "./styles";

export interface DeleteProductConfirmationModalHandles {
  open: () => void;
  close: () => void;
}
interface DeleteProductConfirmationModalProps {
  closeModal?: () => void;
  onSubmit: () => void;
  loadingAction?: boolean;
}

const DeleteProductConfirmationModal: ForwardRefRenderFunction<
  DeleteProductConfirmationModalHandles,
  DeleteProductConfirmationModalProps
> = (props, ref) => {
  const { t: translate } = useTranslation();
  const classes = useStyles();
  const { closeModal, loadingAction, onSubmit } = props;

  const [openModal, setOpenModal] = useState<boolean>(false);
  const open = useCallback(() => {
    setOpenModal(true);
  }, []);
  const close = useCallback(() => {
    setOpenModal(false);
  }, []);

  useImperativeHandle(ref, () => ({
    open,
    close,
  }));
  const onClose = () => {
    if (closeModal) closeModal();
    close();
  };
  const onDelete = () => {
    onSubmit();
  };

  return (
    <ConfirmationModal
      data-cy="deleteModal"
      width="520px !important"
      open={openModal}
      closeModal={onClose}
      type="error"
      title={translate("deleteProduct")}
      leftIconTitle={<MdOutlineCancel color="#F04438" size={20} />}
      loading={loadingAction}
      cancelDisabled={loadingAction}
      customColorCancel={Color.TEXT_INFO}
      customColorSave={Color.ERROR}
      textCancel={translate("cancel")}
      textSubmit={translate("delete")}
      submit={onDelete}
    >
      <Grid container spacing={2} className="mt-2">
        <Grid item className={classes.cancelModalContainer}>
          <div data-cy="confirmationModalCancelBody" className={classes.descriptionModalConfirm}>
            <span>{`${translate("areYouSureYouWantToDeleteThisProduct")}`} ?</span>
            <span className="error">{translate("thisActionIsPermanentAndCannotBeUndone")}</span>
          </div>
        </Grid>
      </Grid>
    </ConfirmationModal>
  );
};

export default forwardRef(DeleteProductConfirmationModal);
